const route = {
	name: 'evaluation-360',
	path: 'evaluation',
	component: () => import('@/modules/evaluation-360/pages/page-evaluation'),
	meta: {
		title: 'Evaluación',
	},
	redirect: 'evaluation-360/list-process',
	props: true,
	children: [
		// {
		// 	name: 'list-process',
		// 	path: 'list-process',
		// 	component: () => import('@/modules/evaluation-360/pages/page-list-process'),
		// 	meta: {
		// 		title: 'Lista de Proceso',
		// 	},
		// },
		{
			name: 'process',
			path: 'process',
			component: () => import('@/modules/evaluation-360/pages/page-process'),
			meta: {
				title: 'Procesos',
			},
			redirect: 'process/list-process',
			children: [
				{
					name: 'list-process',
					path: 'list-process',
					component: () => import('@/modules/evaluation-360/pages/page-list-process'),
					meta: {
						title: 'Lista de Procesos',
					},
				},
				{
					name: 'new-process',
					path: 'new-process',
					component: () => import('@/modules/evaluation-360/pages/page-new-process'),
					meta: {
						title: 'Nuevo Proceso',
					},
					redirect: '/process/new-process/configuration-process',
					children: [
						{
							name: 'process-configuration-process',
							path: 'configuration-process',
							component: () => import('@/modules/evaluation-360/pages/process-steps-pages/page-configuration-process'),
							meta: {
								title: 'Configurar Proceso',
							},
						},
						{
							name: 'process-choose-employees',
							path: 'choose-employees',
							component: () => import('@/modules/evaluation-360/pages/process-steps-pages/page-choose-employees'),
							meta: {
								title: 'Escoger Empleado',
							},
						},
						{
							name: 'process-choose-evaluators',
							path: 'choose-evaluators',
							component: () => import('@/modules/evaluation-360/pages/process-steps-pages/page-choose-evaluators'),
							meta: {
								title: 'Escoger Evaluadores',
							},
						},
					],
				},
				{
					name: 'edit-process',
					path: 'edit-process/:id',
					component: () => import('@/modules/evaluation-360/pages/page-new-process'),
					meta: {
						title: 'Editar Proceso',
					},
					redirect: '/process/edit-process/configuration-process',
					children: [
						{
							name: 'edit-configuration-process',
							path: 'configuration-process',
							component: () => import('@/modules/evaluation-360/pages/process-steps-pages/page-configuration-process'),
							meta: {
								title: 'Editar Configuración',
							},
						},
						{
							name: 'edit-choose-employees',
							path: 'choose-employees',
							component: () => import('@/modules/evaluation-360/pages/process-steps-pages/page-choose-employees'),
							meta: {
								title: 'Editar Empleados',
							},
						},
						{
							name: 'edit-choose-evaluators',
							path: 'choose-evaluators',
							component: () => import('@/modules/evaluation-360/pages/process-steps-pages/page-choose-evaluators'),
							meta: {
								title: 'Editar Evaluadores',
							},
						},
					],
				},
			],
		},
		{
			name: 'report',
			path: 'report',
			component: () => import('@/modules/evaluation-360/pages/page-report-evaluation'),
			meta: {
				title: 'Reportes',
			},
			props: true,
			redirect: 'report/report-evaluation',
			children: [
				{
					name: 'report-evaluation',
					path: 'report-evaluation/:id',
					component: () => import('@/modules/evaluation-360/pages/report-evaluation'),
					meta: {
						title: 'Reporte de Evaluación',
					},
				},
				{
					name: 'evaluation-summary',
					path: 'evaluation-summary',
					component: () => import('@/modules/evaluation-360/components/evaluation/report-summary'),
					meta: {
						title: 'Evaluación',
					},
				},
				{
					name: 'dashboard',
					path: 'dashboard/:processId/:pollId',
					component: () => import('@/modules/evaluation-360/components/dashboard/evaluation'),
					meta: {
						title: 'Dashboard',
						layout: 'layout-dashboard',
					},
				},
			],
		},
		{
			name: 'evaluation360-polls',
			path: 'evaluation360-polls',
			component: () => import('@/modules/evaluation-360/pages/page-evaluations360-polls'),
			meta: {
				title: 'Evaluaciones',
			},
			redirect: 'evaluation360-polls/list-polls-evaluation360',
			children: [
				{
					name: 'list-polls-evaluation360',
					path: 'list-polls-evaluation360',
					component: () => import('@/modules/evaluation-360/pages/page-list-polls-evaluation360'),
					meta: {
						title: 'Evaluaciones',
					},
				},
			],
		},
	],
};
export default route;



// WEBPACK FOOTER //
// ./src/modules/evaluation-360/router/index.js